import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'TRUNCATE',
  category: FunctionCategory.MATH,
  description:
    'Truncates each number in a column or a single number to the specified number of decimal places.',
  shortDescription: 'Truncates to number of decimal places',
  params: [
    {
      name: 'value',
      type: ArgType.number,
      description: 'Either a column or number to truncate to num_places number of places.',
    },
    {
      name: 'num_places',
      type: ArgType.number,
      description: 'Either a column or number, the number of decimal places to truncate to.',
    },
  ],
} satisfies AnalysisFunction;
